import React from 'react';
import { CheckCircle2, ShieldCheck, BadgeCheck, Ghost, HelpCircle, UserCheck } from 'lucide-react';

interface VerificationBadgeProps {
  level?: 'none' | 'silver' | 'gold' | 'blue';
  trustLevel?: 'shadow' | 'community-vouched' | 'verified-silver' | 'certified-gold' | 'official-blue';
  isShadow?: boolean;
  size?: number;
  showText?: boolean;
  className?: string;
}

export const VerificationBadge: React.FC<VerificationBadgeProps> = ({ 
  level = 'none', 
  trustLevel,
  isShadow = false,
  size = 18,
  showText = false,
  className = ''
}) => {
  // Normalize props to internal level
  let effectiveLevel = level;
  let effectiveShadow = isShadow;

  if (trustLevel) {
    if (trustLevel === 'shadow') effectiveShadow = true;
    else if (trustLevel === 'verified-silver') effectiveLevel = 'silver';
    else if (trustLevel === 'certified-gold') effectiveLevel = 'gold';
    else if (trustLevel === 'official-blue') effectiveLevel = 'blue';
    else if (trustLevel === 'community-vouched') effectiveLevel = 'community' as any;
  }

  if (effectiveShadow) {
    return (
      <div className={`flex items-center gap-1.5 px-2 py-0.5 bg-gray-100 text-gray-500 rounded-full border border-gray-200 group relative cursor-help ${className}`}>
        <Ghost size={size - 2} />
        <span className="text-[10px] font-bold uppercase tracking-wider">Shadow Profile</span>
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-gray-900 text-white text-[10px] rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
          Perfil pré-criado com dados públicos. Não reivindicado pelo proprietário.
        </div>
      </div>
    );
  }

  const getIcon = () => {
    switch (effectiveLevel) {
      case 'silver':
        return <CheckCircle2 size={size} className="text-slate-400" />;
      case 'gold':
        return <ShieldCheck size={size} className="text-amber-500" />;
      case 'blue':
        return <BadgeCheck size={size} className="text-blue-500" />;
      case 'community' as any:
        return <UserCheck size={size} className="text-emerald-500" />;
      default:
        return null;
    }
  };

  const getLabel = () => {
    switch (effectiveLevel) {
      case 'silver': return 'Verificado';
      case 'gold': return 'Certificado';
      case 'blue': return 'Oficial';
      case 'community' as any: return 'Recomendado';
      default: return '';
    }
  };

  const icon = getIcon();
  if (!icon) return null;

  return (
    <div className={`flex items-center gap-1 ${className}`} title={getLabel()}>
      {icon}
      {showText && <span className="text-xs font-bold uppercase tracking-tight">{getLabel()}</span>}
    </div>
  );
};
